import React from 'react';
import { useTranslation } from 'react-i18next';
import { Key } from 'lucide-react';

interface FreeKeysHeaderProps {
    message?: string;
    canViewFull: boolean;
}

export const FreeKeysHeader: React.FC<FreeKeysHeaderProps> = ({ message, canViewFull }) => {
    const { t } = useTranslation('common');

    return (
        <div className="mb-6 space-y-4">
            <div className="flex items-center gap-4">
                <div className="p-3 bg-gradient-to-br from-yellow-500 to-orange-600 rounded-lg shadow-lg text-white">
                    <Key size={32} />
                </div>
                <div>
                    <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
                        {t('freeKeys.header.title')}
                    </h1>
                </div>
            </div>

            {message && (
                <div className={`p-4 rounded-lg border flex items-start gap-3 ${canViewFull ? 'bg-green-50 border-green-200 text-green-800' : 'bg-amber-50 border-amber-200 text-amber-800'
                    }`}>
                    <div className="mt-1">
                        {canViewFull ? (
                            <span className="text-xl">✅</span>
                        ) : (
                            <span className="text-xl">🔒</span>
                        )}
                    </div>
                    <div className="font-medium text-sm md:text-base">
                        {!canViewFull ? t('freeKeys.header.restrictedWarning') : message}
                    </div>
                </div>
            )}
        </div>
    );
};
